import { render } from "./Cur-news.vue?vue&type=template&id=66ec07c4&scoped=true"
import script from "./Cur-news.vue?vue&type=script&lang=js"
export * from "./Cur-news.vue?vue&type=script&lang=js"

import "./Cur-news.vue?vue&type=style&index=0&id=66ec07c4&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ec07c4"]])

export default __exports__